import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export namespace NCmsBlockQuickLinks {
    export const BLOCK_ID = 'search-quick-links';
    export interface IBlockDataContent {
        description?: string;
        links?: IBlockDataElement[];
    }
    export interface IBlockDataElement {
        label?: string;
        link?: string;
    }
}
@Component({
    selector: 'search-quick-links',
    templateUrl: 'search-quick-links.html',
    styleUrls: ['search-quick-links.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, HrefComponent, CarouselModule, ICmsClientModule]
})
@ICmsComponent<SearchQuickLinksComponent>({
    id: NCmsBlockQuickLinks.BLOCK_ID,
    block: {
        url: NCmsBlockQuickLinks.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Search Quick Links Layout',
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'links',
            title: 'Qucik Link',
            itemName: 'Quick Link',
            itemNameField: 'Quick Link',
            defaultSize: 1,
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'label',
                    title: 'Link Copy'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'link',
                    title: 'Link URL'
                }
            ]
        }
    ]
})
export class SearchQuickLinksComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NCmsBlockQuickLinks.IBlockDataContent;
    klevuSearchService = inject(KlevuSearchService);
    message?: string;
    @Input()
    set term(value: string) {
        this.updateMessage(value);
    }
    private updateMessage(searchTerm: string) {
        this.klevuSearchService.loadKlevuVars(() => {
            const messages = this.klevuSearchService.noSearchResultsMessages;
            this.message =
                messages?.find(m => m.showForTerms?.includes(searchTerm))?.message || messages?.find(m => m.showForTerms === null)?.message;
            this.message = this.message?.replace('#', searchTerm);
        });
    }
}
